(function() {
    window.c24.birthday = {
        update: function(e) {
            const birthday = $(e.target).closest('.js24Birthday');
            const field = $(this);
            if (field.val() == '' && e.keyCode == 8) {
                if (field.hasClass('month')) {
                    $('.js24Day', birthday).focus();
                } else if (field.hasClass('year')) {
                    $('.js24Month', birthday).focus();
                }
            } else {
                if (field.hasClass('day') && field.val() > 3) {
                    $('.js24Month', birthday).focus();
                } else if (field.hasClass('month') && field.val() > 1) {
                    $('.js24Year', birthday).focus();
                }
            }
        },
    };

    $(document).ready(function() {
        if ($('.js24Birthday').length) {
            const js24Birthday = $('.js24Birthday .js24Day,.js24Birthday .js24Month,.js24Birthday .js24Year');
            js24Birthday.on('keyup', window.c24.birthday.update);
            js24Birthday.on('paste', window.c24.birthday.update);
            js24Birthday.on('input', window.c24.birthday.update);
        }
    });
})();
